import type { MouseEvent as ReactMouseEvent } from 'react';

export type PopupCloseEvent = ReactMouseEvent | KeyboardEvent | PopStateEvent;

export type PopupCloseHandler = (event?: PopupCloseEvent) => void;

const isDialogOrSheetContainer = (element: Element | null): boolean => {
  const qa = element?.getAttribute('data-qa');

  return qa === 'Dialog' || qa === 'Sheet';
};

const isCloseIconElement = (element: EventTarget | null): boolean => {
  if (!(element instanceof Element)) {
    return false;
  }

  const iconElement = element.getAttribute('data-qa') === 'Icon' ? element : element.closest('[data-qa="Icon"]');

  if (!iconElement) {
    return false;
  }

  return isDialogOrSheetContainer(iconElement.parentElement);
};

export const createCloseOnIconOnlyHandler = (onClose: () => void): PopupCloseHandler => {
  return (event) => {
    if (!event || !isCloseIconElement(event.currentTarget)) {
      return;
    }

    onClose();
  };
};

export const createPopupCloseHandler = (onClose: () => void, isMobile: boolean): PopupCloseHandler => {
  if (isMobile) {
    return () => {
      onClose();
    };
  }

  return createCloseOnIconOnlyHandler(onClose);
};
